module.exports = __webpack_public_path__ + "static/media/04_plantilla_combo_rectangular_marco_comida_13.7d62986e.png";